'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListController = function ListController(ModelFactory, $stateParams, Resource, $scope) {
  "ngInject";

  (0, _classCallCheck3.default)(this, ListController);
  var vm = this;
  vm.name = '';
  vm.viewType = "grid"; //grid | list
  vm.model = {};
  vm.modelEnum = "";
  vm.items = [];
  vm.dots = 200;
  init();

  function init() {
    vm.model = ModelFactory.getByEnum($stateParams.modelEnum);
    vm.modelEnum = $stateParams.modelEnum;

    Resource.getList(vm.model.name).then(function (res) {
      console.log("Resource:", res.data);
      vm.items = _lodash2.default.filter(res.data, vm.model.name + '.active');
    });

    $scope.$watch('vm.viewType', function (newValue) {
      console.log("View type cambiato:", newValue);
      if (newValue == 'list') {
        vm.dots = 500;
      } else {
        vm.dots = 200;
      }
    });
  };
};

exports.default = ListController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/list/list.controller.js